<template>
  <el-container class="index-el-container">
    <aside style="background-color: #2d3a4b; text-align: left">
      <SideBar :isCollapse="isCollapse" />
    </aside>
    <el-container class="bottom-container">
      <el-header class="index-header">
        <Top :isCollapse="isCollapse" @toShow="toShow" />
      </el-header>

      <el-main>
        <el-collapse-transition>
          <keep-alive>
            <router-view
              :key="$route.path"
              v-if="$route.meta.keepAlive"
            ></router-view>
          </keep-alive>
        </el-collapse-transition>
        <el-collapse-transition>
          <router-view
            :key="$route.path"
            v-if="!$route.meta.keepAlive"
          ></router-view>
        </el-collapse-transition>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { SideBar, Top } from "./components";
export default {
  data() {
    return {
      User: "",
      activeIndex: "1",
      windowHeight: document.documentElement.clientHeight - 80 + "px",
      windowWidth: document.documentElement.clientWidth,
      indexstyle: {
        height: document.documentElement.clientHeight + "px",
        width: document.documentElement.clientWidth + "px",
      },
      menus: [], //菜单栏
      isCollapse: false,
    };
  },
  components: {
    SideBar,
    Top,
  },
  created() {},
  mounted() {
    let vm = this;
    vm.isCollapse = window.innerWidth <= 1366;
    window.onresize = function () {
      vm.isCollapse = this.innerWidth <= 1366;
    };
  },
  methods: {
    toShow() {
      this.isCollapse = !this.isCollapse;
    },
  },
};
</script>

<style scoped>
.index-header {
  background-color: #fff;
  position: relative;
}
.index-breadcrumb {
  padding: 5px 0 15px 0;
}

.index-el-container {
  height: 100%;
}
.index-el-container .menu-fontsize {
  font-size: 14px;
}

.el-menu {
  border: none !important;
}

.box {
  height: 100%;
}

.header-icon {
  width: 80px;
  height: 80px;
  float: left;
  margin-top: 10px;
}

.el-aside {
  color: #333;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.bottom-container {
  height: 100vh;
}
</style>
